<template>
  <div :class="$style.result">
    <h1>Ты молодец!</h1>
    <div :class="$style.plate">
      Набрано
      <h1>{{ scoreNumber }}/{{ max }}</h1>
      {{ scoreText }}
    </div>
  </div>
</template>
<script>
import { TweenMax } from 'gsap'

import plural from '@/utils/plural'

export default {
  name: 'Result',
  props: {
    max: {
      type: Number,
      default: 25,
    },
  },
  data: () => ({
    proxyScore: 0,
  }),
  mounted() {
    TweenMax.to(this, 1, { proxyScore: this.score })
  },
  computed: {
    score() {
      return this.$store.state.result
    },
    scoreText() {
      return plural(this.score, 'Балл', 'Балла', 'Баллов')
    },
    scoreNumber() {
      return this.proxyScore < 10 ? `0${Math.floor(this.proxyScore)}` : `${Math.floor(this.proxyScore)}`
    },
  },
}
</script>
<style lang="scss" module>
.result {
  padding-top: 2rem;
  text-align: center;
}

.plate {
  position: absolute;
  top: 42%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 1.5rem;
  box-shadow: 0 0.6rem 1rem rgba(0, 0, 0, 0.15), 0 0.1px 0.3rem rgba(0, 0, 0, 0.2);
  width: 42rem;
  height: 28rem;
  padding: 3rem;

  h1 {
    font-size: 11.8rem;
    line-height: 1.3220338983;
    letter-spacing: -0.1em;
    color: #FF003D;
    margin-top: -0.6rem;
  }
}
</style>
